import { is } from 'bpmn-js/lib/util/ModelUtil';

/**
 * Personalisation du "popupMenu" de bpmn-js : le menu qui s'affiche
 * lorsqu'on clique sur un élément puis la clé à molette.
 */
export default class CustomPopupMenu {
  constructor(create, elementFactory, popupMenu, translate) {
    this.create = create;
    this.elementFactory = elementFactory;
    this.translate = translate;

    popupMenu.registerProvider("bpmn-replace", this);
  }

  getPopupMenuEntries(element) {
    return (entries) => {

      // Start Event
      delete entries['replace-with-none-intermediate-throwing'];
      delete entries['replace-with-message-start'];
      delete entries['replace-with-timer-start'];
      delete entries['replace-with-signal-start'];
      delete entries['replace-with-conditional-start'];

      // End Event
      delete entries['replace-with-none-intermediate-throw'];
      delete entries['replace-with-message-end'];
      delete entries['replace-with-escalation-end'];
      delete entries['replace-with-compensation-end'];
      delete entries['replace-with-signal-end'];
      delete entries['replace-with-terminate-end'];

      // Task
      delete entries['replace-with-receive-task'];
      delete entries['replace-with-manual-task'];
      delete entries['replace-with-rule-task'];
      delete entries['replace-with-script-task'];
      delete entries['replace-with-call-activity'];
      delete entries['replace-with-collapsed-subprocess'];
      delete entries['replace-with-expanded-subprocess'];

      // Flux
      delete entries['replace-with-conditional-flow'];
      // Flux par défaut (replace-with-default-flow)
      // => seulement si l'élément source est une UserTask ou SendTask
      if (!element.source || !(is(element.source, 'bpmn:UserTask') || is(element.source, 'bpmn:SendTask'))) {
        delete entries['replace-with-default-flow'];
      }

      // Gateway
      delete entries['replace-with-inclusive-gateway'];
      delete entries['replace-with-complex-gateway'];
      delete entries['replace-with-event-based-gateway'];

      return entries;
    }
  }
}

CustomPopupMenu.$inject = [
  'create',
  'elementFactory',
  'popupMenu',
  'translate'
];